export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export interface CategoryItem {
  key: string;
  url: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    key: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20stylish%20pair%20of%20pastel%20mint%20and%20white%20running%20sneakers%20photographed%20at%20a%20low%20three%20quarter%20angle%20against%20a%20soft%20blush%20pink%20seamless%20studio%20backdrop%20with%20gentle%20diffused%20window%20light%20and%20a%20subtle%20soft%20shadow%20beneath%20for%20a%20clean%20modern%20ecommerce%20look&width=600&height=600&seq=usfans-cat-shoes&orientation=square&nocache=true",
  },
  {
    key: "hoodiesSweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20oatmeal%20beige%20hoodie%20sweater%20neatly%20folded%20and%20stacked%20on%20a%20rustic%20light%20wooden%20table%20with%20a%20warm%20afternoon%20glow%20and%20a%20small%20sprig%20of%20dried%20eucalyptus%20beside%20it%20for%20a%20relaxed%20lifestyle%20catalog%20feel&width=600&height=600&seq=usfans-cat-hoodies&orientation=square&nocache=true",
  },
  {
    key: "tShirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Several%20colorful%20cotton%20t-shirts%20in%20coral%20terracotta%20mustard%20and%20olive%20green%20hanging%20on%20a%20minimal%20wooden%20clothing%20rack%20against%20a%20soft%20sage%20green%20painted%20wall%20with%20soft%20natural%20side%20lighting%20and%20a%20clean%20airy%20composition&width=600&height=600&seq=usfans-cat-tshirts&orientation=square&nocache=true",
  },
  {
    key: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20classic%20blue%20denim%20jacket%20draped%20over%20a%20vintage%20woven%20rattan%20chair%20in%20a%20bright%20sunlit%20corner%20with%20white%20walls%20and%20a%20leafy%20green%20plant%20nearby%20creating%20a%20fresh%20casual%20editorial%20lifestyle%20scene&width=600&height=600&seq=usfans-cat-jackets&orientation=square&nocache=true",
  },
  {
    key: "pantsShorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Casual%20chino%20pants%20and%20a%20pair%20of%20shorts%20laid%20flat%20in%20a%20tidy%20arrangement%20on%20a%20crisp%20white%20marble%20surface%20with%20subtle%20grey%20veining%20and%20soft%20overhead%20studio%20lighting%20for%20a%20refined%20minimal%20apparel%20display&width=600&height=600&seq=usfans-cat-pants&orientation=square&nocache=true",
  },
  {
    key: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20modern%20unstructured%20baseball%20cap%20in%20a%20soft%20sky%20blue%20tone%20resting%20on%20a%20stack%20of%20pastel%20colored%20hardcover%20books%20against%20a%20warm%20peach%20studio%20background%20with%20soft%20diffused%20light%20and%20clean%20minimal%20styling&width=600&height=600&seq=usfans-cat-headwear&orientation=square&nocache=true",
  },
  {
    key: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20matching%20two%20piece%20loungewear%20set%20of%20hoodie%20and%20joggers%20in%20a%20soft%20lavender%20tone%20arranged%20on%20crisp%20white%20linen%20bedding%20with%20soft%20morning%20light%20and%20airy%20negative%20space%20for%20a%20cozy%20premium%20lifestyle%20shot&width=600&height=600&seq=usfans-cat-sets&orientation=square&nocache=true",
  },
  {
    key: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20soft%20organic%20cotton%20underwear%20in%20muted%20grey%20and%20cream%20tones%20displayed%20on%20a%20light%20natural%20bamboo%20tray%20with%20a%20tiny%20ceramic%20dish%20and%20soft%20diffused%20lighting%20for%20a%20gentle%20minimal%20wellness%20aesthetic&width=600&height=600&seq=usfans-cat-underwear&orientation=square&nocache=true",
  },
  {
    key: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20vibrant%20modern%20sports%20jersey%20in%20a%20bold%20terracotta%20and%20cream%20colorway%20hanging%20on%20a%20minimal%20matte%20black%20hanger%20against%20a%20warm%20neutral%20studio%20wall%20with%20dramatic%20soft%20side%20light%20and%20clean%20composition&width=600&height=600&seq=usfans-cat-jersey&orientation=square&nocache=true",
  },
  {
    key: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20curated%20flat%20lay%20of%20fashion%20accessories%20including%20round%20sunglasses%20a%20slim%20leather%20watch%20and%20a%20small%20cardholder%20arranged%20on%20a%20travertine%20stone%20surface%20with%20warm%20golden%20hour%20light%20and%20soft%20shadows&width=600&height=600&seq=usfans-cat-accessories&orientation=square&nocache=true",
  },
  {
    key: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20structured%20tan%20leather%20backpack%20and%20a%20matching%20small%20crossbody%20handbag%20standing%20on%20a%20beige%20linen%20draped%20surface%20against%20a%20light%20warm%20neutral%20backdrop%20with%20soft%20natural%20window%20light%20and%20premium%20editorial%20styling&width=600&height=600&seq=usfans-cat-bags&orientation=square&nocache=true",
  },
  {
    key: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Several%20handcrafted%20leather%20belts%20in%20warm%20brown%20camel%20and%20black%20tones%20neatly%20coiled%20and%20displayed%20on%20a%20dark%20walnut%20wooden%20surface%20with%20soft%20directional%20lighting%20for%20a%20rich%20artisanal%20accessory%20catalog%20shot&width=600&height=600&seq=usfans-cat-belts&orientation=square&nocache=true",
  },
  {
    key: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=An%20elegant%20minimal%20glass%20perfume%20bottle%20with%20a%20gold%20cap%20standing%20on%20a%20soft%20sage%20green%20silk%20fabric%20with%20a%20few%20scattered%20petals%20and%20gentle%20diffused%20light%20for%20a%20delicate%20luxury%20fragrance%20editorial&width=600&height=600&seq=usfans-cat-perfumes&orientation=square&nocache=true",
  },
  {
    key: "otherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylish%20assortment%20of%20everyday%20lifestyle%20items%20including%20a%20cap%20socks%20a%20water%20bottle%20and%20a%20tote%20bag%20arranged%20on%20a%20warm%20grey%20concrete%20ledge%20against%20a%20textured%20neutral%20wall%20with%20soft%20natural%20light%20and%20modern%20minimal%20styling&width=600&height=600&seq=usfans-cat-other&orientation=square&nocache=true",
  },
];